module.exports = __webpack_public_path__ + "static/media/table.de925bed.svg";